import { TdBody, TrBody } from '@any-ui-react/table';
import classNames from 'classnames';
import type { PropsWithChildren, ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';

import { DEFAULT_COLUMN_MAX_WIDTH } from '../constants';
import type { TableProps } from '../Table';
import { TableDesktopContainer } from './TableDesktopContainer';

export function TableSkeleton<T extends Record<string, unknown>>(
  props: PropsWithChildren<TableProps<T> & { skeletonCount?: number }>,
): ReactElement {
  const { layout, rowClassName, skeletonCount, loading, children, data = [], numOfStickyCols = 1 } = props;

  if (loading) {
    return (
      <TableDesktopContainer<T> data={data} numOfStickyCols={numOfStickyCols} {...props}>
        {new Array(skeletonCount).fill(null).map((_, index) => (
          <TrBody key={index} className={classNames('h-10', rowClassName)}>
            {layout.map(({ accessor, tdClassName, minWidth, maxWidth, width, skeletonTemplate }, i) => {
              const resolvedTdClassName = typeof tdClassName === 'function' ? tdClassName(null) : tdClassName;
              const isLastColTd = i === layout.length - 1;
              return (
                <TdBody
                  key={accessor}
                  className={classNames(rowClassName, resolvedTdClassName, {
                    'overflow-hidden': isLastColTd,
                  })}
                  style={{
                    minWidth: minWidth || 'none',
                    maxWidth: maxWidth || `${DEFAULT_COLUMN_MAX_WIDTH}px`,
                    width: width,
                    background: 'inherit',
                    zIndex: i < numOfStickyCols ? 1 : 0,
                  }}
                >
                  {skeletonTemplate || <Skeleton />}
                </TdBody>
              );
            })}
          </TrBody>
        ))}
      </TableDesktopContainer>
    );
  }
  return <>{children}</>;
}
